import { render, staticRenderFns } from "./right_lateral_knee_f.vue?vue&type=template&id=21509072"
import script from "./right_lateral_knee_f.vue?vue&type=script&lang=js"
export * from "./right_lateral_knee_f.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports